
/**
 * Кнопка-ссылка через границу приложений: своя зона - nuxt-link,
 * чужая - <a href> с полной перезагрузкой.
 * @see ~/plugins/app-zones.ts
 */
import { computed, defineComponent, useContext } from '@nuxtjs/composition-api'
import { SvoiButtonLink } from '@svoi-ui/components/button'
import { LinkTypesEnum } from '@svoi-ui/interfaces/link-type'

export default defineComponent({
  name: 'AppButtonLink',
  components: { SvoiButtonLink },
  inheritAttrs: false,
  props: {
    link: {
      type: String,
      required: true
    }
  },
  setup(props) {
    const { $appZones } = useContext()

    const componentType = computed(() => ($appZones.isOwnRoute(props.link) ? LinkTypesEnum.nuxtLink : LinkTypesEnum.a))

    return { componentType }
  }
})
